import script from "./UploadFileBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFileBtn.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFileBtn.vue?vue&type=style&index=0&id=4cad1676&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cad1676"]])

export default __exports__